import React, { Component } from 'react';
import './Signin.css';
import Navbar from '../Components/Navbar/Navbar'
import logoblue from '../../image/logoblue.png'
import { Link } from 'react-router-dom';
import axios from 'axios'
import { LinkAPI } from '../../API/API'
import HandleRes from '../Components/HandleRes/HandleRes';
import Footer from '../Components/Footer/Footer'

class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "user@user.com",
      password: "123456789",
      emailError: "",
      passwordError: "",
      networkError: false,
      errordatamessage: false,
      errordatamessagetext: '',
      hasError: false,
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  handleChange = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
      [event.target.name]: isCheckbox
        ? event.target.checked
        : event.target.value
    });
  };

  validate = () => {
    let emailError = "";
    let passwordError = "";
    // let passwordError = "";

    if (this.state.password.length < 8) {
      passwordError = "write your password correct";
      console.log()
    }

    if (!this.state.email.includes("@")) {
      emailError = "invalid email";
    }

    if (emailError || passwordError) {
      this.setState({ emailError, passwordError });
      return false;
    }

    return true;
  };

  handleSubmit = event => {
    event.preventDefault();
    const { email, password } = this.state
    const isValid = this.validate();
    if (isValid) {
      console.log(this.state);
      axios.post(`${LinkAPI}/api/businessowner/login`, { email: email, password: password }
      ).then(res => {
        localStorage.setItem("userToken", res.data.businessOwner.token)
        localStorage.setItem("KaynuserName", res.data.businessOwner.name)
        console.log( res)
        window.location.replace("/orders");

      }).catch(error => {
        console.log(error.response)
        if (!error.response) {
          this.setState({
            networkError: true
          })
        }else if (error.response.status===400) {
          localStorage.setItem("userTokentConfirmData", error.response.data.token)
          window.location.replace("/ConfirmPhone");

        }else if (error.response.data.message) {
          this.setState({
            emailError: "",
            passwordError: "",
            errordatamessage: true,
            errordatamessagetext: error.response.data.message
          })
        } else {
          this.setState({
            hasError: true,
          })
        }
      })
    }
  };
  render() {
    document.title ="Kayn | Sign In"; 
    document.getElementsByTagName("META")[1].content="Kayn Sign In";
    document.documentElement.lang = 'en';

    return (
      <div className="AppEN signin">
        <Navbar />
        <div className='container'>
          <div className="Sign row my-0">
            <div className=" logoform col-6 d-flex align-content-end flex-wrap ">
              <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/"><img className="logo" src={logoblue} alt="Kayn" /></Link>       </div>
              <p className="fontsize2 text-center mb-5 col-12">Your package...your way</p>
            </div>
            <div className="col-md-6 form float-md-right  ">
              <div className="contantform text-center p-4 ">
                <h3 className="fontsize1 my-4">Sign In </h3>
                <p className="fontsize6 mt-4 mb-1">Sign in to continue access pages</p>
                <p className="fontsize6  m-0">E-mail:user@user.com</p>
                <p className="fontsize6 m-0">password:123456789</p>
                <p className="fontsize6  m-0">to sign in as a admin <Link to="/admin/Signin">Click here</Link></p>
                <form className="px-lg-5" onSubmit={this.handleSubmit}>
                  <div className="form-group mb-4 mt-1">
                    <input type="email" className={"form-control badge-pill p-3 noborder " + (this.state.emailError ? 'is-invalid' : '')} placeholder="Email Address" name="email" value={this.state.email}
                      onChange={this.handleChange} required />
                    <div style={{ fontSize: 12, color: "red" }}>
                      {this.state.emailError}
                    </div>
                  </div><div className="form-group mt-4 mb-1">
                    <input type="password" className={"form-control badge-pill p-3 noborder " + (this.state.passwordError ? 'is-invalid' : '')} placeholder=" password" name="password" value={this.state.password}
                      onChange={this.handleChange} required />
                    <div style={{ fontSize: 12, color: "red" }}>
                      {this.state.passwordError}
                    </div>
                    {(this.state.errordatamessage ?
                      <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                        {this.state.errordatamessagetext}
                      </div> : '')}
                  </div>
                  <div className="text-right py-1">
                    <Link to="/ForgetPassword"><span className="pointer fontsize11 text-muted py-1 my-1">Forget Password ?</span></Link>
                  </div>
                  <button type="submit" className="btn btn-primary badge-pill btn-block shadow p-2 mb-2"  >LOGIN</button>
                </form>
                <div className="mt-5 px-5">
                  <p className="fontsize6 my-4">Don't have an account yet ?</p>
                  <Link to="/SignUp" className="btn badge-pill btn-block p-2 border shadow"  >SIGN UP</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
        {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
        {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

      </div>
    )
  }
}
export default Signin;